"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const clsx = require("../../../chunks/clsx-CBkIpawf.js");
require("react");
require("../../../foundations/icons/IconsDefault.js");
const foundations_typography_Text_Text = require("../../../foundations/typography/Text/Text.js");
const progressContainer = "_progressContainer_196kj_1";
const progressLabel = "_progressLabel_196kj_8";
const progressElement = "_progressElement_196kj_12";
const styles = {
  progressContainer,
  progressLabel,
  progressElement
};
const Progress = ({ label, max, value, id, className, ...props }) => /* @__PURE__ */ jsxRuntime.jsxs("div", { className: clsx.clsx(styles.progressContainer, className), ...props, children: [
  /* @__PURE__ */ jsxRuntime.jsx(
    "progress",
    {
      id,
      max,
      value,
      "aria-labelledby": `${id}-label`,
      "aria-valuenow": value,
      "aria-valuemax": max,
      className: styles.progressElement,
      children: value && `${(value > max ? 100 : value / max * 100).toFixed(2)}%`
    }
  ),
  /* @__PURE__ */ jsxRuntime.jsx(foundations_typography_Text_Text.Text, { id: `${id}-label`, variant: "text-caption-head", className: styles.progressLabel, children: label })
] });
exports.Progress = Progress;
